module.exports = __webpack_public_path__ + "static/media/rs.cb94f075.ico";


//////////////////
// WEBPACK FOOTER
// ./src/components/res/rs.ico
// module id = 58
// module chunks = 0